import { render, staticRenderFns } from "./promos.vue?vue&type=template&id=282f8991&scoped=true&"
import script from "./promos.vue?vue&type=script&lang=js&"
export * from "./promos.vue?vue&type=script&lang=js&"
import style0 from "./promos.vue?vue&type=style&index=0&id=282f8991&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f8991",
  null
  
)

export default component.exports